import { atom } from 'recoil';

export const jwtData = atom({
  key: 'jwtData',
  default: null
});
